const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.756 352.381v149.064c-2.728 0-5.455-.641-7.967-1.923L17.569 445.37C11.407 442.231 7.5 435.73 7.5 428.618V300.389c0-3.586.993-7.015 2.769-9.942l121.487 61.934zM210.462 463.462 256 440.253V289.04l-124.241 63.342v149.06c2.721 0 5.455-.641 7.959-1.923l38.882-19.817",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 289.04-124.241 63.342-121.495-61.939c1.681-2.758 4.064-5.08 6.967-6.628l114.529-61.552L256 289.04zM380.244 352.381v149.064c2.728 0 5.455-.641 7.967-1.923l106.22-54.151c6.162-3.139 10.069-9.64 10.069-16.752v-128.23c0-3.586-.993-7.015-2.768-9.942l-121.488 61.934zM380.241 352.382v149.06c-2.721 0-5.455-.641-7.959-1.923L256 440.253V289.04l124.241 63.342z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.1 256.737 256 289.04l124.241 63.342 121.495-61.939c-1.681-2.758-4.064-5.08-6.967-6.628l-50.38-27.076M256 138.273V289.04l-124.241-66.777-.003-135.977c0-3.586.993-7.015 2.768-9.941L256 138.273zM256 289.04V138.273l121.47-61.928a19.167 19.167 0 0 1 2.768 9.941l.001 27.396M377.47 76.344 256 138.273 134.524 76.344c1.682-2.763 4.059-5.08 6.961-6.634l106.204-57.055c.029-.012.053-.03.082-.042a17.473 17.473 0 0 1 16.534.042L370.509 69.71c2.902 1.555 5.285 3.871 6.961 6.634z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.996 173.149c-13.313-14.562-32.466-23.696-53.752-23.696-40.212 0-72.81 32.598-72.81 72.81s32.598 72.81 72.81 72.81 72.81-32.598 72.81-72.81c0-6.178-.769-12.176-2.218-17.904",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.089 225.329 24.257 22.476 42.759-44.952",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.3c170ea54dabbf9978b13782e15f631f.svg";
export { ForwardRef as ReactComponent };